import { render, staticRenderFns } from "./qcrbOrderDetail.vue?vue&type=template&id=9743852c&scoped=true&"
import script from "./qcrbOrderDetail.vue?vue&type=script&lang=js&"
export * from "./qcrbOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./qcrbOrderDetail.vue?vue&type=style&index=0&id=9743852c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9743852c",
  null
  
)

export default component.exports